(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }
    hide() {
      super.hide();
      window.pauseAllMedia();
    }
    show(opener) {
      super.show(opener);
      //this.showActiveMedia();
      this.constProductPageSwiperCall();
    }
    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();
      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
    constProductPageSwiperCall(showActiveMedia) {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      let activeMediaIndex = 0;

      this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
        if (element == activeMedia) {
          activeMediaIndex = index;
        }
      });
      const prodPageSwiper = new Swiper('#featured-product-swiper', {
        zoom: true,
        centeredSlides: false,
        slidesPerView: 1,
        autoheight: true,
        watchSlidesVisibility: false,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        init: false,
        navigation: {
          nextEl: '.swiper-button-next-prod-page',
          prevEl: '.swiper-button-prev-prod-page',
        },
      });
      prodPageSwiper.on('init', function () {
        prodPageSwiper.slideTo(activeMediaIndex, 0, false);
      });
      prodPageSwiper.init();
      document.querySelector('.product-media-modal__toggle').addEventListener('click', function () {
        prodPageSwiper.destroy();
      });
    }
  }

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations--single');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };
      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-modal', ProductModal);
  customElements.define('product-recommendations--single', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    connectedCallback() {
      this.handleClickOutside = this.handleClickOutside.bind(this);
      document.addEventListener('click', this.handleClickOutside);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleClickOutside);
    }

    handleClickOutside(event) {
      if (!this.contains(event.target)) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.headerId = document.getElementById("section-header").getAttribute('data-header-id');
		this.header = document.getElementById(`shopify-section-${this.headerId}`);
		this.headerBounds = {};
		this.currentScrollTop = 0;

		this.onScrollHandler = this.onScroll.bind(this);

		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		observer.observe(this.header);
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.hide.bind(this));
		if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
			this.predictiveSearch.onFocusOut();
			this.predictiveSearch.onBlur();
		}
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.reveal.bind(this));
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
	}

	this.currentScrollTop = scrollTop;
	}

	hide() {
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');

		if(this.header.classList.contains('header-overlay')){
			this.header.classList.remove('color-background-4');
			this.header.classList.add('overlay-effect');
			this.header.classList.remove('color-background-overlay');
		}
		const headerMobile = document.querySelector('.header-mobile-section');

		if(headerMobile.classList.contains('header-overlay')){
			headerMobile.classList.remove('color-background-4');
			headerMobile.classList.add('overlay-effect');
			headerMobile.classList.remove('color-background-overlay');
		}
	}

	reset() {
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		const headerMobile = document.querySelector('.header-mobile-section');

		if(this.header.classList.contains('header-overlay')){
			this.header.classList.add('color-background-4');
			this.header.classList.remove('color-background-1');
			this.header.classList.remove('overlay-effect');
			this.header.classList.add('color-background-overlay');
		}

		if(headerMobile.classList.contains('header-overlay')){
			headerMobile.classList.add('color-background-4');
			headerMobile.classList.remove('color-background-1');
			headerMobile.classList.remove('overlay-effect');
			headerMobile.classList.add('color-background-overlay');
		}
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		this.disclosures.forEach(disclosure => disclosure.close());
	}

	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }
    hide() {
      super.hide();
      window.pauseAllMedia();
    }
    show(opener) {
      super.show(opener);
      //this.showActiveMedia();
      this.constProductPageSwiperCall();
    }
    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();
      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }

    constProductPageSwiperCall(showActiveMedia) {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      let activeMediaIndex = 0;

      this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
        if (element == activeMedia) {
          activeMediaIndex = index;
        }
      });
      const prodPageSwiper = new Swiper('#product-page-swiper', {
        zoom: true,
        centeredSlides: false,
        slidesPerView: 1,
        autoheight: true,
        watchSlidesVisibility: false,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        init: false,
        navigation: {
          nextEl: '.swiper-button-next-prod-page',
          prevEl: '.swiper-button-prev-prod-page',
        },
        pagination: {
          el: '.swiper-pagination-product-page',
          clickable: true,
        },
        //on: {
        //	click: function (e) {
        //			if (this.zoom.scale === 1) {
        //			this.zoom.in();
        //			} else {
        //				this.zoom.out();
        //			}
        //	 },
        //},
      });
      prodPageSwiper.on('init', function () {
        prodPageSwiper.slideTo(activeMediaIndex, 0, false);
      });
      prodPageSwiper.init();
      document.querySelector('.product-media-modal__toggle').addEventListener('click', function () {
        prodPageSwiper.destroy();
      });
    }
  }

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations--single');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-modal', ProductModal);
  customElements.define('product-recommendations--single', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
  /* Arrow scrolling for the product slider. Scrolls by one card and
     disables each button when there is nothing further that way. */
  (function () {
    function stepOf(track) {
      var card = track.querySelector('li');
      if (!card) return track.clientWidth;
      var cs = window.getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap || 0) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    /* Half the height of a card's image, published to the row so the arrows
       can sit on the middle of the image rather than the middle of the whole
       card (which includes the title and price underneath). */
    function positionArrows(row) {
      var media = row.querySelector(
        '.product-slider__track .card__media, .product-slider__track .media'
      ) || row.querySelector('.product-slider__track img');
      if (!media) return;
      var h = media.getBoundingClientRect().height;
      if (h > 0) row.style.setProperty('--ps-arrow-top', h / 2 + 'px');
    }

    function refresh(row) {
      positionArrows(row);
      var track = row.querySelector('.product-slider__track');
      if (!track) return;
      var max = track.scrollWidth - track.clientWidth - 1;
      var prev = row.querySelector('.product-slider__arrow--prev');
      var next = row.querySelector('.product-slider__arrow--next');
      if (prev) prev.disabled = track.scrollLeft <= 0;
      if (next) next.disabled = max <= 0 || track.scrollLeft >= max;
    }

    function refreshAll() {
      var rows = document.querySelectorAll('.product-slider__row');
      for (var i = 0; i < rows.length; i++) refresh(rows[i]);
    }

    function bind() {
      var rows = document.querySelectorAll('.product-slider__row');
      for (var i = 0; i < rows.length; i++) {
        (function (row) {
          if (row.dataset.psBound) return;
          row.dataset.psBound = '1';
          var track = row.querySelector('.product-slider__track');
          if (!track) return;
          track.addEventListener('scroll', function () { refresh(row); }, { passive: true });
          refresh(row);

          /* Images arrive after first paint, and the media box changes height
             at every tier, so keep the measurement current. */
          var imgs = track.querySelectorAll('img');
          for (var n = 0; n < imgs.length; n++) {
            if (!imgs[n].complete) {
              imgs[n].addEventListener('load', function () { positionArrows(row); }, { once: true });
            }
          }

          if (window.ResizeObserver) {
            var media = track.querySelector('.card__media, .media') || track.querySelector('img');
            if (media) new ResizeObserver(function () { positionArrows(row); }).observe(media);
          }
        })(rows[i]);
      }
    }

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('.product-slider__arrow');
      if (!btn || btn.disabled) return;
      var row = btn.closest('.product-slider__row');
      var track = row && row.querySelector('.product-slider__track');
      if (!track) return;
      event.preventDefault();
      var dir = btn.classList.contains('product-slider__arrow--next') ? 1 : -1;
      if (track.scrollBy) {
        track.scrollBy({ left: dir * stepOf(track), behavior: 'smooth' });
      } else {
        track.scrollLeft += dir * stepOf(track);
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bind);
    } else {
      bind();
    }
    window.addEventListener('load', refreshAll);
    window.addEventListener('resize', refreshAll);
    document.addEventListener('shopify:section:load', bind);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  /* Set --vh to 1% of the actual visible viewport height. On mobile
     Safari, 100vh includes the area behind the address bar, which
     makes "full-screen" elements taller than the visible area. Using
     calc(var(--vh) * 100) gives us a true visible full-height. We
     update on resize AND on orientationchange so the value stays
     accurate when the address bar shows/hides. */
  document.addEventListener('DOMContentLoaded', function () {
    function appHeight() {
      const doc = document.documentElement;
      doc.style.setProperty('--vh', window.innerHeight * 0.01 + 'px');
    }

    appHeight();
    window.addEventListener('resize', appHeight);
    window.addEventListener('orientationchange', appHeight);
  });

  /* ------------------------------------------------------------------
     Video lightbox for the "Gradient feature" slide layout.
     - Shopify-hosted video: the <video> element is rendered up-front
       with preload="none" and is played/paused on open/close.
     - External (YouTube/Vimeo): the iframe is injected on open and
       removed on close, so nothing loads until the user asks for it.
     ------------------------------------------------------------------ */
  (function () {
    function frameOf(modal) {
      return modal.querySelector('.gradient-video-modal__frame');
    }

    function openModal(modal) {
      var frame = frameOf(modal);
      modal.classList.add('is-open');
      document.body.classList.add('gradient-modal-open');

      var video = frame.querySelector('video');
      if (video) {
        try {
          video.currentTime = 0;
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } catch (e) {}
      }

      var embed = frame.getAttribute('data-gvm-embed');
      if (embed && !frame.querySelector('iframe')) {
        var iframe = document.createElement('iframe');
        iframe.setAttribute('src', embed);
        iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
        iframe.setAttribute('allowfullscreen', 'true');
        iframe.setAttribute('title', 'Video');
        frame.appendChild(iframe);
      }
    }

    function closeModal(modal) {
      var frame = frameOf(modal);
      modal.classList.remove('is-open');
      document.body.classList.remove('gradient-modal-open');

      var video = frame.querySelector('video');
      if (video) {
        try {
          video.pause();
          video.currentTime = 0;
        } catch (e) {}
      }

      var iframe = frame.querySelector('iframe');
      if (iframe) iframe.parentNode.removeChild(iframe);
    }

    function closeAll() {
      document.querySelectorAll('.gradient-video-modal.is-open').forEach(closeModal);
    }

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-gvm-open]');
      if (opener) {
        var modal = document.getElementById(opener.getAttribute('data-gvm-open'));
        if (modal) {
          event.preventDefault();
          openModal(modal);
        }
        return;
      }

      var closer = event.target.closest('[data-gvm-close]');
      if (closer) {
        var openModalEl = closer.closest('.gradient-video-modal');
        if (openModalEl) {
          event.preventDefault();
          closeModal(openModalEl);
        }
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' || event.key === 'Esc') closeAll();
    });

    /* Theme editor: close any open lightbox when a section reloads. */
    document.addEventListener('shopify:section:load', closeAll);
    document.addEventListener('shopify:section:select', closeAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
